import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    routeKey: 1,
    uploadData: null,
    menus: require('./menus.js').default,
    langs: require('./langs.js').default,
    recruit: require('./recruit.js').default,
    keepAliveInclude: ['identifier', 'preset-identifier', 'ark-identifier'],
  },
  mutations: {
    routeReload(state) {
      state.routeKey++
    },
    setUploadData(state, payload) {
      state.uploadData = payload
    },
    setMenus(state, menus) {
      state.menus = menus
    },
    setBrands(state, brands) {
      state.brands = brands
    },
  },
  actions: {},
  modules: {},
})
